const parallaxBlocks = document.querySelectorAll('.js-parallax-block');
const windowHeight = document.documentElement.clientHeight;

const markActive = (scrollY) => {
  parallaxBlocks.forEach((el) => {
    const items = el.querySelectorAll('.js-parallax-item');
    if (el.getBoundingClientRect().top <= windowHeight * 2) {
      el.classList.add('parallax');
      items.forEach((item) => {
        let speed = item.dataset.speed;
        item.style.transform = `translate3d(0, ${(el.offsetTop - scrollY) * speed}px, 0)`;
      });
    } else {
      el.classList.remove('parallax');
      items.forEach((item) => {
        item.style.transform = null;
      });
    }
  });
}

const addParallax = () => {
  if (parallaxBlocks) {
    let scrollY = window.pageYOffset;
    markActive(scrollY);

    window.addEventListener('scroll', () => {
      scrollY = window.pageYOffset;
      markActive(scrollY);
    });

    window.addEventListener('resize', () => {
      scrollY = window.pageYOffset;
      markActive(scrollY);
    });
  }
}

export {addParallax};
